<template>
	<div class="about">
		<Search :bool='true' />
		<ListWork />
		<div class="ziList">
			<HospitalInfo></HospitalInfo>
			<!-- <LeftList :bool='false' :num='1400'></LeftList> -->
		</div>
		<Footer />
	</div>
</template>

<script>
	// @ is an alias to /src
	// import HelloWorld from "@/components/HelloWorld.vue";
	import ListWork from "@/components/ListWork.vue";
	import Search from "@/components/Search.vue";
	import Footer from "@/components/Footer.vue";
	import HospitalInfo from "@/components/HospitalInfo.vue";
	// import LeftList from "@/components/LeftList.vue";
	

	export default {
		name: "Home",
		components: {
			Search,
			ListWork,
			HospitalInfo,
			Footer,
			// LeftList
		},
		
	};
</script>
<style lang="scss" scoped="scoped">
	.about {
		height: 100%;

	}
	.ziList {
		width: 1200px;
		// height: 100px;
		// background-color: #0f1;
		margin: 0 auto;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
</style>
